export default __webpack_public_path__ + "static/media/send.eb0283fa.svg";